import { Box, Chip, Typography } from '@mui/material'
import React from 'react'
import StatusBadge from '../../../v2/MUI_custom_component/Badge/StatusBadge';
import { GiftStatusEnum } from '../../../v2/Benefits/Rewards/utils';
import { toCapitalized } from '../../../v2/Utils/Capitalize';
import { useNavigate } from 'react-router-dom';
const RewardsCard = ({reward, key, selectedNetworkESI, selectedCompanyEntity, selectedManufacturer }) => {  
    const navigate = useNavigate();
    const statusData = Object.values(GiftStatusEnum).find(
        (s) => s.status === reward.status,
    );  
    return (
        <Box 
            key={reward.gift_id || key}
            sx={{ 
                display: 'flex', 
                // alignItems: 'center',
                p: 2,
                backgroundColor: '#FFF',
                borderRadius: 2,
                justifyContent: 'space-between',
            }}
            onClick={() => {
                navigate('/benefits/reward-detail', {
                state: {
                    gift_id: reward.gift_id,
                    selectedCompanyEntity: selectedCompanyEntity,
                    type:'NETWORK_INFLUENCER',
                    esi_id: selectedNetworkESI,
                    selectedManufacturer: selectedManufacturer,
                },
            });
            }}
        >
            
            <Box sx={{ display: 'flex',
                gap: {xs: 1, md: 3},
                width: '40%',
                borderRight: '1px solid #E0E0E0',
            }}>
                <Box>
                    <Box sx={{backgroundColor:"#F7F7F7", p:1, borderRadius:2, display: "flex",alignItems: "center", justifyContent: "center",}}>
                        <Box
                            component={'img'}
                            src={reward?.src}
                            alt="event"
                            sx={{ width: 32, height: 32, objectFit: 'contain' }}
                        />
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', textAlign: 'center', justifyContent: 'center', gap: 1, pr: 1 }}>
                    <Typography variant="labelM" sx={{ color: '#666' }}>
                        Gift Name
                    </Typography>
                    <Typography variant="bodyD" sx={{ fontWeight: 600 }}>
                        {toCapitalized(reward.name)}
                    </Typography>
                </Box>
            </Box>
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'center',
                borderRight: '1px solid #E0E0E0',
                width: '30%',
                textAlign: 'center',
                gap: 1

            }}>
                <Typography variant="labelM" sx={{ color: '#666' }}>
                    Gift Status
                </Typography>
                <StatusBadge label={statusData.label} />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column',  width: '30%',  textAlign: 'center', gap: 1 }}>
                <Typography variant="labelM" sx={{ color: '#666' }}>
                    Date
                </Typography>
                <Typography variant="bodyD" sx={{ fontWeight: 600 }}>
                    {reward.date}
                </Typography>
            </Box>
        </Box>
    )
}

export default RewardsCard